<template>

  <v-sheet class="ma-3 pa-5" elevation="1" v-if="item">

    <div class="text-center">

      <v-icon color="accent" x-large>mdi-account-card-details-outline</v-icon>
      <h3 class="display-1 primary--text">{{item.properties.Name}}</h3>

      <v-sheet tile class="pa-3 mt-1 grey lighten-3 text-center">
        {{item.properties.Descriptio}}
      </v-sheet>

    </div>

    <v-container grid-list-md>

      <v-layout>

        <v-flex xs12 sm6>

          <v-simple-table id="partner-info" dense light class="transparent xs-small-table">
            <tbody>
            <tr>
              <td>Business Category:</td>
              <td>{{item.properties.Category}}</td>
            </tr>
            <tr>
              <td>Type:</td>
              <td>{{item.properties.Type}}</td>
            </tr>
            <tr>
              <td>Address:</td>
              <td>{{item.properties.Address}}</td>
            </tr>
            <tr>
              <td>Zip Code:</td>
              <td>{{item.properties.Zipcode}}</td>
            </tr>
            <tr v-if="item.properties.URL">
              <td>URL:</td>
              <td><a :href="item.properties.URL"
                     v-text="item.properties.URL"
                     target="_blank"></a></td>
            </tr>
            <tr>
              <td>Speed:</td>
              <td>
                <SpeedTableCell :value="item.properties.Speed"></SpeedTableCell>
              </td>
            </tr>
            </tbody>
          </v-simple-table>

          <!--            <div v-html="item.properties.Video" style="width: 100%;"></div>-->

          <!--            <pre>{{item.properties.Video}}</pre>-->

          <div class="text-center mt-2" v-if="item.properties.Video.trim()">
            <youtube :video-id="getVideoId(item.properties.Video)" resize fit-parent/>
          </div>

        </v-flex>

        <v-flex xs12 sm6>

          <v-card class="fill-height">

            <StandardMap ref="mapContainer"
                         height="100%"
                         @map-ready="handleMapLoad"
                         :include-service-areas-layer="false"
                         :symbolized-layer="false"
                         :scale="false"
                         :locate="false"
            >
              <!--              <l-circle-marker v-if="item" :lat-lng="latlng" :z-index-offset="1000" color="red"></l-circle-marker>-->

              <!--              <l-marker v-if="item" :lat-lng="latlng" :z-index-offset="1000"></l-marker>-->

              <l-marker ref="marker" v-if="item" :lat-lng="latlng">

                <!--                <l-tooltip :options="tipOptions">-->
                <!--                  <span v-html="tip"></span>-->
                <!--                </l-tooltip>-->

                <l-icon
                  :icon-anchor="[2, 20]"
                  class-name="icon-scale-50 v-icon mdi mdi-map-marker red--text">
                  <div class="headline"></div>
                </l-icon>

                <l-icon
                  :icon-anchor="[6, 24]"
                  class-name="icon-scale-50 v-icon mdi mdi-map-marker primary--text">
                  <div class="headline"></div>
                </l-icon>

              </l-marker>

              <l-control position="bottomleft">
                <v-btn small
                       class="white primary--text mb-3"
                       @click="showOnMap"
                       :ripple="false"
                >
                  <v-icon left class="">mdi-crosshairs</v-icon>
                  Center Partner Location
                </v-btn>
              </l-control>

            </StandardMap>

          </v-card>

        </v-flex>

      </v-layout>

    </v-container>

  </v-sheet>

</template>

<script>
import StandardMap from './map-components/StandardMap';
import SpeedTableCell from './SpeedTableCell';

export default {

  name: 'Partner.Card',

  components: { StandardMap, SpeedTableCell, },

  props: {

    items: {
      type: Array,
      required: true,
    },

  },

  data() {
    return {
      marker: null,
      tipOptions: {
        direction: 'bottom',
        permanent: true,
        offset: [0, 10],
        className: 'text-center',
      },
    };
  },

  watch: {

    latlng() {
      console.log('latlng watcher');
      this.$nextTick(() => {
        this.showOnMap();
      });
    },

  },

  computed: {

    id() {
      return Number(this.$route.params.id);
    },

    item() {
      if (this.id && this.items.length) {
        return this.items.find(i => i.id === this.id);
      }
      return null;
    },

    latlng() {
      if (this.item) {
        console.log(this.item);
        return [
          this.item.geometry.coordinates[1],
          this.item.geometry.coordinates[0]
        ];
      }
    },

    tip() {
      if (this.item) {
        return `
        <b>${this.item.properties.Name}</b><br>
        ${this.item.properties.Address}<br>
       `;
      }
    },

  },

  methods: {

    handleMapLoad() {
      this.showOnMap();
      this.$refs.mapContainer.map.invalidateSize();
    },

    showOnMap() {
      const map = this.$refs.mapContainer.map;
      const latLng = this.$refs.marker.latLng;
      if (map && this.item) {
        map.invalidateSize();
        console.log(map.getBounds());
        if (!map.getBounds().contains(latLng))
          map.setView(latLng, 15);
      }
    },

    getVideoId(videoString) {
      console.log(`"${videoString}"`);
      if (videoString.trim()) {
        return videoString.split('embed/')[1].split('"')[0];
      }
      return null;
    },

  },

};
</script>

<style lang="scss">

  #partner-info > v-data-table__wrapper th {
    color: red !important;
    text-align: right;
    width: 150px;
  }

  #partner-info td:first-child {
    width: 180px;
    min-width: 80px;
  }

</style>
